import React from 'react';

const Lungs = props => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M12 3V12M12 12C12 12 10 10 8 10C6 10 4 11 3 13C2 15 2 17 3 19C4 21 6 22 8 21C10 20 11 18 12 16M12 12C12 12 14 10 16 10C18 10 20 11 21 13C22 15 22 17 21 19C20 21 18 22 16 21C14 20 13 18 12 16"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M8 14C8 14 9 15 10 15"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
    />
    <path
      d="M16 14C16 14 15 15 14 15"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
    />
  </svg>
);

export default Lungs;
